import { type ActionKey, type PlayerKey, type ViewMode } from "../vowGameLogic";

const PUBLIC_URL = process.env.PUBLIC_URL ?? "";
const ACTION_ICON_BASE = `${PUBLIC_URL}/ActionIcons`;
const ROLE_ICON_BASE = ACTION_ICON_BASE;

export type IconConfig = {
  src: string;
  alt: string;
};

export const ACTION_ICONS: Record<ActionKey, IconConfig> = {
  graze: {
    src: `${ACTION_ICON_BASE}/Graze.png`,
    alt: "Graze livestock action",
  },
  harvest: {
    src: `${ACTION_ICON_BASE}/Cut-Reed.png`,
    alt: "Harvest reeds action",
  },
  hunt: {
    src: `${ACTION_ICON_BASE}/Hunt.png`,
    alt: "Hunt action",
  },
  protect: {
    src: `${ACTION_ICON_BASE}/Nature-Reserve.png`,
    alt: "Establish nature reserve action",
  },
  install_nest: {
    src: `${ACTION_ICON_BASE}/bittern.png`,
    alt: "Install nesting platform action",
  },
};

export const TILE_STATUS_ICONS = {
  protected: {
    src: `${ACTION_ICON_BASE}/Nature-Reserve.png`,
    alt: "Nature reserve tile",
  },
  nest: {
    src: `${ACTION_ICON_BASE}/Nest.png`,
    alt: "Bittern nest attempt",
  },
  nestSuccess: {
    src: `${ACTION_ICON_BASE}/Success.png`,
    alt: "Successful nesting",
  },
} as const;

export const MAP_VIEW_ICONS: Partial<Record<ViewMode, IconConfig>> = {
  habitat: {
    src: `${ACTION_ICON_BASE}/Topology.png`,
    alt: "Habitats view icon",
  },
  water_level: {
    src: `${ACTION_ICON_BASE}/Water-Level.png`,
    alt: "Water level view icon",
  },
  D: {
    src: `${ACTION_ICON_BASE}/duck.png`,
    alt: "Duck score icon",
  },
  BHQ: {
    src: `${ACTION_ICON_BASE}/bittern.png`,
    alt: "Bittern habitat score icon",
  },
  BIO: {
    src: `${ACTION_ICON_BASE}/Land-Type_Biom.png`,
    alt: "Biodiversity score icon",
  },
};

export const ROLE_ICONS: Record<PlayerKey, IconConfig> = {
  herder: {
    src: `${ROLE_ICON_BASE}/Stockbreeder.png`,
    alt: "Stock Breeder role icon",
  },
  reed_harvester: {
    src: `${ROLE_ICON_BASE}/Reed-Harvester.png`,
    alt: "Reed Harvester role icon",
  },
  hunter: {
    src: `${ROLE_ICON_BASE}/Hunter.png`,
    alt: "Hunter role icon",
  },
  protector: {
    src: `${ROLE_ICON_BASE}/Conservationist-NGO.png`,
    alt: "Conservationist role icon",
  },
  bittern: {
    src: `${ROLE_ICON_BASE}/bittern.png`,
    alt: "Bittern role icon",
  },
};
